import { Link } from 'gatsby'
import React from 'react'
import { cn } from '../../../Utils/component'
import type { ButtonProps } from '../../ui/button/types'
import { buttonClassName } from '../../ui/button/utils'

interface LinkButtonProps {
  title?: string
  href: string
  label: string
  isInverted?: boolean
  isExternal?: boolean
  size?: ButtonProps['size']
  color?: string
  onClick?: () => void
  children?: React.ReactNode
  className?: string
}

export const LinkButton = ({
  title = undefined,
  href,
  label,
  isInverted = false,
  isExternal = false,
  size,
  color,
  onClick = () => undefined,
  children = undefined,
  className = '',
}: LinkButtonProps) => {
  const classes = buttonClassName({
    color: color || 'primary',
    invert: isInverted,
    size,
  })

  return isExternal ? (
    <a
      title={title || label}
      href={href}
      target="_blank"
      className={cn(classes, className)}
      rel="noreferrer"
      onClick={onClick}
    >
      {children || label}
    </a>
  ) : (
    <Link
      title={title || label}
      to={href}
      className={cn(classes, className)}
      onClick={onClick}
    >
      {children || label}
    </Link>
  )
}
